import "bootstrap/dist/css/bootstrap.min.css";
import { Container, Row, Col, Image } from 'react-bootstrap';
import GreatCharitiesOne from "../../../assests/images/donate to-nonprofits-immage/charity-do-donate-1.webp";
import GreatCharitiesTwo from "../../../assests/images/donate to-nonprofits-immage/charity-do-donate-2.webp";
import {
    FavoriteNonprofitsBanner,
    FindGreatCharitiesSection,
    FavoriteNonprofitsWrap,
    FavoriteNonprofitsBox,
    FavoriteNonprofitsImage,
    FavoriteNonprofitsContent,
    FavoriteNonprofitsTitle,
    FavoriteNonprofitsText,
    FavoriteNonprofitsStrong,
    StatisticsDonationSection,
    StatisticsDonationTitle,
    StatisticsDonationWrap,
    StatisticsDonationBox,
    StatisticsDonationStrong,
    StatisticsDonationText,
    StatisticsDonationUnorderedList,
    StatisticsDonationListView,
    DonationListViewStrong,
    HowToUseSection,
    HowToUseWrap,
    HowToUseTitle,
    HowToUseBoxWrap,
    HowToUseBox,
    HowToUseBoxTitle,
    HowToUseBoxText,
    HowToUseBoxStrong,
} from "./donateToNonprofitsStyle"
import {
    ElliottAdvocacyBanner,
    AdvocacyTitle,
    AdvocacyText,
} from "../../../components/common/commonSubPageBanner/commonSubPageBannerStyle";
import { useNavigate } from "react-router-dom";
import { MESSAGE } from "../../../utils/message";
import { Helmet } from 'react-helmet';
import { openInNewTab } from "../../../utils/functions";


const DonateToNonprofits = () => {
    const navigate = useNavigate();
    return (
        <>
            <Helmet>
                <meta name="viewport" content="width=device-width, initial-scale=1" id="wixDesktopViewport"></meta>
                <meta httpEquiv="X-UA-Compatible" content="IE=edge"></meta>
                <meta name="generator" content="Wix.com Website Builder"></meta>
                <meta name="wix-dynamic-custom-elements" content=""></meta>
                <meta name="format-detection" content="telephone=no"></meta>
                <meta name="skype_toolbar" content="skype_toolbar_parser_compatible"></meta>
                <meta httpEquiv="X-Wix-Meta-Site-Id" content="9285e98b-8ae0-4020-82ec-8402e2a49a27"></meta>
                <meta httpEquiv="X-Wix-Application-Instance-Id" content="197b0634-6a04-4f68-9a3b-c0377814abd3"></meta>
                <meta httpEquiv="X-Wix-Published-Version" content="3048"></meta>
                <meta httpEquiv="etag" content="bug"></meta>
                <meta property="og:title" content="Donate to Nonprofits | GreatNonprofits"></meta>
                <meta property="og:image" content="https://static.wixstatic.com/media/196996_3096a2e2829f492e8495c525c961782d%7Emv2.jpg/v1/fit/w_2500,h_1330,al_c/196996_3096a2e2829f492e8495c525c961782d%7Emv2.jpg"></meta>
                <meta property="og:image:width" content="2500"></meta>
                <meta property="og:image:height" content="1330"></meta>
                <meta property="og:url" content="https://www.about.greatnonprofits.org/donate-to-nonprofits"></meta>
                <meta property="og:site_name" content="aboutgreatnonprofits"></meta>
                <meta property="og:type" content="website"></meta>
                <meta name="fb_admins_meta_tag" content="greatnonprofits"></meta>
                <meta property="fb:admins" content="greatnonprofits"></meta>
                <meta name="twitter:card" content="summary_large_image"></meta>
                <meta name="twitter:title" content="Donate to Nonprofits | GreatNonprofits"></meta>
                <meta name="twitter:image" content="https://static.wixstatic.com/media/196996_3096a2e2829f492e8495c525c961782d%7Emv2.jpg/v1/fit/w_2500,h_1330,al_c/196996_3096a2e2829f492e8495c525c961782d%7Emv2.jpg"></meta>
            </Helmet>
            <>

                <FavoriteNonprofitsBanner>
                    <ElliottAdvocacyBanner className="donate-to-nonprofits-banner">
                        <Container className="cont-w">
                            <AdvocacyTitle className='title-sub-page'>Find Great Charities</AdvocacyTitle>
                            <AdvocacyText className="page-content">Donate to nonprofits that align with your passions and values, whether it's supporting education, environmental conservation, or social justice initiatives.</AdvocacyText>
                        </Container>
                    </ElliottAdvocacyBanner>

                </FavoriteNonprofitsBanner>

                <FindGreatCharitiesSection>
                    <Container className="cont-w">
                        <Row>
                            <Col lg="12">
                                <FavoriteNonprofitsWrap>
                                    <FavoriteNonprofitsBox>
                                        <FavoriteNonprofitsImage>
                                            <Image src={GreatCharitiesOne} alt="Data Integration One" />
                                        </FavoriteNonprofitsImage>

                                        <FavoriteNonprofitsContent>
                                            <FavoriteNonprofitsTitle>Which Charity Do I Donate to?</FavoriteNonprofitsTitle>
                                            <FavoriteNonprofitsText>With over 1.3 million charitable organizations in the United States, finding a charity to donate to can be challenging.</FavoriteNonprofitsText>
                                            <FavoriteNonprofitsText>Choosing where to donate and how to donate is important; you want your charitable gift to make an impact. GreatNonprofits reviews help you identify the organizations in your community that are making a difference on the issues you care about.</FavoriteNonprofitsText>
                                        </FavoriteNonprofitsContent>
                                    </FavoriteNonprofitsBox>

                                    <FavoriteNonprofitsBox>
                                        <FavoriteNonprofitsImage>
                                            <Image src={GreatCharitiesTwo} alt="Data Integration One" />
                                        </FavoriteNonprofitsImage>

                                        <FavoriteNonprofitsContent>
                                            <FavoriteNonprofitsTitle>What Do I Donate and How Much?</FavoriteNonprofitsTitle>
                                            <FavoriteNonprofitsText>There are a number of ways to make charitable contributions. The <FavoriteNonprofitsStrong onClick={() => openInNewTab("https://nccs.urban.org/statistics/quickfacts.cfm")}>National Center for Charitable Statistics</FavoriteNonprofitsStrong> estimates that individual donors gave more than $211 billion to charities in 2010.</FavoriteNonprofitsText>
                                            <FavoriteNonprofitsText>You may want to give money to a charity, but car donations, clothing donations, furniture donations, and other in-kind charitable gifts are also important to charities. A donation of any amount helps reduce the amount of time the organization spends fundraising and increases the amount of time they can spend on their mission.</FavoriteNonprofitsText>
                                        </FavoriteNonprofitsContent>
                                    </FavoriteNonprofitsBox>

                                </FavoriteNonprofitsWrap>
                            </Col>
                        </Row>
                    </Container>
                </FindGreatCharitiesSection>

                <StatisticsDonationSection>
                    <Container className="cont-w">
                        <Row>
                            <Col lg="12">
                                <StatisticsDonationTitle>{MESSAGE.statisticsOnDonation}</StatisticsDonationTitle>
                            </Col>
                        </Row>

                        <Row>
                            <Col lg="12">
                                <StatisticsDonationWrap>
                                    <StatisticsDonationBox>
                                        <StatisticsDonationText>The <StatisticsDonationStrong onClick={() => openInNewTab("https://www.americorps.gov/")}>Corporation for National and Community Service</StatisticsDonationStrong> estimates that in 2010</StatisticsDonationText>

                                        <StatisticsDonationUnorderedList>
                                            <StatisticsDonationListView>
                                                individual donors gave more than <DonationListViewStrong>$211 billion</DonationListViewStrong> to charities!
                                            </StatisticsDonationListView>
                                        </StatisticsDonationUnorderedList>
                                    </StatisticsDonationBox>

                                    <StatisticsDonationBox>
                                        <StatisticsDonationText>And based on <StatisticsDonationStrong onClick={() => navigate('/blogs/1')}>research</StatisticsDonationStrong> conducted by nonprofit software <StatisticsDonationStrong onClick={() => openInNewTab("https://www.softwareadvice.com/nonprofit/")}>comparison and analysis firm, Software Advice:</StatisticsDonationStrong></StatisticsDonationText>
                                        <StatisticsDonationUnorderedList>
                                            <StatisticsDonationListView>
                                                individual donors gave more than <DonationListViewStrong>$211 billion</DonationListViewStrong> to charities!
                                            </StatisticsDonationListView>
                                        </StatisticsDonationUnorderedList>
                                    </StatisticsDonationBox>
                                </StatisticsDonationWrap>
                            </Col>
                        </Row>

                    </Container>
                </StatisticsDonationSection>

                <HowToUseSection>
                    <Container className="cont-w">
                        <Row>
                            <Col sm="12">
                                <HowToUseWrap>
                                    <HowToUseTitle>How to Use GreatNonprofits to Find Nonprofits</HowToUseTitle>

                                    <HowToUseBoxWrap>

                                        <HowToUseBox>
                                            <HowToUseBoxTitle>Search for a Charity</HowToUseBoxTitle>
                                            <HowToUseBoxText>Start by <HowToUseBoxStrong onClick={() => navigate("/toprated/nominate")}>searching for a charity in your geographic area</HowToUseBoxStrong> or <HowToUseBoxStrong onClick={() => navigate("/toprated")}>browse top charities</HowToUseBoxStrong> by issue.</HowToUseBoxText>
                                        </HowToUseBox>

                                        <HowToUseBox>
                                            <HowToUseBoxTitle>Read Volunteer Reviews</HowToUseBoxTitle>
                                            <HowToUseBoxText>Read reviews written by other volunteers to learn more about the volunteer experience with that charity</HowToUseBoxText>
                                        </HowToUseBox>

                                        <HowToUseBox>
                                            <HowToUseBoxTitle>Read Client & Donor Reviews</HowToUseBoxTitle>
                                            <HowToUseBoxText>Read reviews written by clients, donors, and other stakeholders to learn what others think about the organization and what kinds of volunteer opportunities are available.</HowToUseBoxText>
                                        </HowToUseBox>

                                        <HowToUseBox>
                                            <HowToUseBoxTitle>Read About the Organization</HowToUseBoxTitle>
                                            <HowToUseBoxText>Read the information the organization has entered on its nonprofit profile to learn more about the charity's programs, community service opportunities, and more.</HowToUseBoxText>
                                        </HowToUseBox>

                                        <HowToUseBox>
                                            <HowToUseBoxTitle>Contact an Organization</HowToUseBoxTitle>
                                            <HowToUseBoxText>Find the organization's website and contact information on the nonprofit profile and get in touch to ask questions.</HowToUseBoxText>
                                        </HowToUseBox>

                                    </HowToUseBoxWrap>

                                </HowToUseWrap>
                            </Col>
                        </Row>
                    </Container>
                </HowToUseSection>

            </>
        </>
    )
};
export default DonateToNonprofits;